/**
 * Утилиты исполнения скриптов из конфигурации (замена прямому eval).
 *
 * Прямой eval блокирует минификацию бандла и даёт предупреждение EVAL при
 * сборке (https://rolldown.rs/guide/troubleshooting#avoiding-direct-eval),
 * а также открывает скриптам весь локальный скоуп вызывающего модуля.
 */

/**
 * Косвенная ссылка на eval: вызов через неё исполняет код в глобальном скоупе,
 * не захватывая локальный скоуп вызывающего модуля.
 *
 * Подходит только для кода без ссылок на локальные переменные вызывающего —
 * для скриптов с параметрами использовать `compileScriptFunction`.
 */
export const indirectEval: typeof eval = eval;

/**
 * Компилирует тело скрипта в функцию с явным списком параметров: скрипт видит
 * только перечисленные параметры и глобальный скоуп.
 *
 * ⚠ Тело исполняется как код — передавать только доверенные скрипты
 * (серверная конфигурация), как и ранее с eval.
 */
export const compileScriptFunction = (params: string[], body: string): ((...args: unknown[]) => unknown) =>
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    new Function(...params, body) as (...args: unknown[]) => unknown;
